import React from 'react'
import { ManageState } from './manageState';
import ContainerLayout from '../../../../components/container-layout/ContainerLayout';
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../../routes/routeName';
import TableCustom from '../../../../components/table/tableCustom';
import StateComponents from '../../../../components/state-component/StateComponents';
import ModalCustom from '../../../../components/modal/ModalCustom';
import { debouncedApiCall } from '../../../../utils/app.utils';
import { useTranslation } from 'react-i18next'

type Props = {}

const ManageCourseOnlinePayment = (props: Props) => {
    const { t } = useTranslation();
    const {
        page,
        pageLimit,
        data,
        sortBy,
        sortType,
        handleRequestSort,
        setPage,
        setPageLimit,
        headCells,
        totalItems,
        renderData,
        setKeyword,
        handleChangeDateRange,
        handleClearDateRange,
        date_range
    } = ManageState();
    return (
        <ContainerLayout
            title={t("จัดการรายการสั่งซื้อ")}
            hidden_sub_title
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: t("จัดการข้อมูลคอร์สออนไลน์"),
                            name: t("จัดการข้อมูลคอร์สออนไลน์"),
                            disabled_match: true,
                            pathName: ""
                        },
                        {
                            key: t("จัดการรายการสั่งซื้อ"),
                            name: t("จัดการรายการสั่งซื้อ"),
                            pathName: routeName.cms.course_online_payment
                        },
                    ]}
                />
            }
            content={
                <div className='w-full'>
                    <StateComponents
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 4
                                },
                                fieldProps: {
                                    placeholder: t("ค้นหา ชื่อ"),
                                    onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setKeyword }),
                                }
                            },
                            {
                                seq: 2,
                                type: "DATE_RANGE",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    onchange: handleChangeDateRange,
                                    value: date_range,
                                    allowClear: true,
                                    onClear: handleClearDateRange,
                                    placeholder: t("ช่วงวันที่")
                                }
                            },
                        ]}
                    />
                    <section className='w-full mt-4'>
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>

                </div>
            }
        />
    )
}

export default ManageCourseOnlinePayment

